/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Tabs,
  Modal,
  DatePicker,
} from 'antd';
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import {
  getEstadosGlobales,
} from 'api/catalogos';
import Table from 'components/Table';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_INACTIVO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  autorizarIPEJALpercepcion,
  deleteIPEJALpercepcion,
  getIPEJALpercepcion, getIPEJALpercepciones, getIPEJALpercepcionesPag, patchIPEJALpercepcion, postIPEJALpercepcion,
} from 'api/nominas/IPEJALPercepciones';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import moment from 'moment/moment';
import { getConfiguracionIncidencias } from 'api/nominas/incidencias/configuracionIncidencias';
import { getTiposDeIncidenciasUnidades } from 'api/nominas/incidencias/tiposIncidenciasUnidades';
import { getAplicaciones } from 'api/catalogos/PeriocidadDeAplicacion';
import { getEvaluacionesAsistencia } from 'api/catalogos/TiposDeEvaluacionAsistencia';
import PercentageInput from 'components/PercentageInput';
import { getPercepcion, getPercepciones } from 'api/nominas/percepciones/percepciones';
import { getIPEJALtasas } from 'api/nominas/IPEJALtasas';
/** cambiarlo en qa */
export const percepcionConfiguracionIPEJALPermission = {
  permissionModel: 'percepcionconfiguracionipejal',
  catalogsModels: [],
  tabsModels: [],
};

const PercepcionConfiguracionIPEJAL = ({ permission }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [pageActual, setPageActual] = useState(1);
  const [percepcion, setPercepcion] = useState([]);
  const [conceptosIpejal, setConceptosIpejal] = useState([]);

  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getIPEJALpercepciones();
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _conceptosIpejal,
        _percepciones,
        _data,
        _estados,
      ] = await Promise.all([
        getIPEJALtasas({ estados_globales: ESTATUS_AUTORIZADO }),
        getPercepciones(),
        getIPEJALpercepciones(),
        getEstadosGlobales(),
      ]);
      if (mounted) {
        setConceptosIpejal(_conceptosIpejal);
        setPercepcion(_percepciones);
        setData(_data);
        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data?.find((item) => item.id === key);
    const _percepcionesConfigIPEJAL = await getIPEJALpercepcion(match.id);

    setTimeout(() => {
      if (_percepcionesConfigIPEJAL) {
        const formValues = {
          ...formatReceived(_percepcionesConfigIPEJAL),
          // Asigna el ID del estado global
          // Convierte la fecha de vigencia final a objeto moment si existe, si no null
          concepto_ipejal: _percepcionesConfigIPEJAL?.concepto_ipejal?.id,
          vigencia_final: _percepcionesConfigIPEJAL.vigencia_final
            ? moment(_percepcionesConfigIPEJAL.vigencia_final)
            : null,
        };
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setDisableFields(_percepcionesConfigIPEJAL?.estados_globales !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const onClickAdd = () => {
    setAdding(true);
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      if (values.vigencia_final?.format) {
        values.vigencia_final = values.vigencia_final.format('YYYY-MM-DD');
      }
      const saved = await (key ? patchIPEJALpercepcion(key, values) : postIPEJALpercepcion(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteIPEJALpercepcion(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Incidencia Validacion ya autorizado');
        return;
      }
      const saved = await autorizarIPEJALpercepcion(key);
      if (saved) {
        const _data = await getIPEJALpercepciones();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Concepto IPEJAL',
      dataIndex: 'concepto_ipejal',
      key: 'concepto_ipejal',
      width: 200,
      render: (_, record) => record?.concepto_ipejal?.concepto || ' ',
    },
    {
      titleText: 'Percepción',
      dataIndex: 'percepcion_ipejal',
      key: 'percepcion_ipejal',
      width: 200,
      render: (val) => {
        const _percepcion = percepcion.find((e) => e.id === val);
        return (
          _percepcion
            ? `${_percepcion.clave} - ${_percepcion.descripcion}` : ''
        );
      },
    },
    {
      titleText: 'Fundamento',
      dataIndex: 'fundamento',
      key: 'fundamento',
      width: 200,
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 150,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 180,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'percepcionconfiguracionipejal', action: 'autorizar' },
                icon: <CheckCircleOutlined />,
                text: 'Autorizar',
                disabledBySelection: true,
                disabled: selectedData?.estados_globales !== ESTATUS_ACTIVO,
                className: 'success',
              },
            ]}
            disableDelete={selectedData?.estados_globales !== ESTATUS_ACTIVO}
            permission={permission}
            allowExportParam={false}
            allowSearch={false}
          />
          <Modal
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Percepciones de Configuración de IPEJAL`}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstErrorDatePicker
              name="Validacion"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
              }}
            >
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="concepto_ipejal"
                  label="Concepto IPEJAL"
                  hasFeedback
                  rules={rules.required}
                >
                  <Select
                    labelProp="concepto"
                    keyProp="id"
                    dataSource={conceptosIpejal}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="percepcion_ipejal"
                  label="Percepción"
                  hasFeedback
                  rules={rules.required}
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={percepcion}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="fundamento"
                  label="Fundamento"
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="vigencia_final"
                  label="Vigencia Final"
                  hasFeedback
                >
                  <DatePicker
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={isAdding || selectedData?.estados_globales === ESTATUS_INACTIVO}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    activeInactive={selectedData?.estados_globales === ESTATUS_ACTIVO}
                    disabled={selectedRowKeys.length <= 0 || disableFields}
                    onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            open={visibleAlert}
            content={`Percepciones de Configuraciones de Ipejal ${form.getFieldValue('concepto_ipejal')?.concepto || ''}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle={`Autorizar Percepciones de Configuraciones de Ipejal ${form.getFieldValue('concepto_ipejal')?.concepto || ''}`}
            open={visibleAutorizar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={() => setVisibleConfirmInactivo(false)}
            ConfirmInactive
            onCancel={() => {
              form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
              setVisibleConfirmInactivo(false);
            }}
            open={visibleConfirmInactivo}
            contentTitle={`Inactivar Percepciones de Configuraciones de Ipejal ${form.getFieldValue('concepto_ipejal')?.concepto || ''}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default PercepcionConfiguracionIPEJAL;
